import { useQuery } from '@tanstack/react-query';
import { searchFunctionalChecklists } from '../services/functional_checklist';

const useSearchFunctionalChecklists = (name = "", pageNumber = 1, pageSize = 5) => {
    const searchChecklistsQuery = useQuery({
        queryKey: ['searchFunctionalChecklists', name, pageNumber, pageSize],
        queryFn: () => searchFunctionalChecklists(name, pageNumber, pageSize),
        enabled: Boolean(name.trim().length > 0)
    });
    return searchChecklistsQuery;
}

export default useSearchFunctionalChecklists; 